import { combineReducers } from "redux";
import auth from "./auth";
import room from "./room";
import cart from "./cart";
import pricing from "./pricing";
import discount from "./discount";
import devices from "./devices";
import profile from "./profile";

export default combineReducers({
    auth,
    room,
    cart,
    pricing,
    discount,
    devices,
    profile,
});
